'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CarouselProgress({
  selectedIndex,
  totalSlides,
}: {
  selectedIndex: number;
  totalSlides: number;
}) {
  return (
    <div className="flex h-[6px] w-full items-center justify-start rounded-full bg-[#eeeeee]">
      <div
        className={cn('h-[6px] rounded-full bg-primary transition-all ease-in-out')}
        style={{ width: `${((selectedIndex + 1) / (totalSlides || 1)) * 100}%` }}
      />
    </div>
  );
}
